import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'
import {
  OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN,
  OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON,
  OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON,
  OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL,
  OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL,
  OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN,
  OUTLET_PAGE_LIST_SET_ON_LOADING,
  OUTLET_PAGE_LIST_SET_OUTLET_DETAIL,
  OUTLET_PAGE_LIST_SET_OUTLET_PRICE,
  OUTLET_PAGE_LIST_SET_OUTLET_SLOTS,
  OUTLET_PAGE_LIST_SET_OUTLETS,
  OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE,
  OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE,
  OUTLET_PAGE_LIST_SET_PROFILE,
  OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET,
  OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS,
  OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS,
  OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON,
  OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL,
  OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL,
  OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL
} from 'actions/outletPages/list/constants'
// The initial application state
let initialState = {
  outlets: [],
  outletDetail: null,
  profile: null,
  outletSlots: null,
  usedOutletSlots: null,
  showConfirmReactivateOutletModal: false,
  reactivatedOutlet: null,
  openRightColumn: false,
  showAddOutletModal: false,
  outletPrice: {},
  featureSubscriptions: [],
  showPaymentGatewayErrorModal: false,
  disablePayButton: false,
  payButtonMessage: 'Pay',
  pendingPaymentMessage: null,
  onLoadingPayButton: false,
  disableSaveOutletButton: false,
  showReactivateOutletWithoutPayModal: false,
  isOnLoadingReactivateOutletWithoutPayModal: false
}

// Takes care of changing the application state
function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  let {payload} = action

  switch (action.type) {
    case OUTLET_PAGE_LIST_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case OUTLET_PAGE_LIST_SET_PROFILE:
      return {...state, profile: payload.profile}
    case OUTLET_PAGE_LIST_SET_OUTLET_DETAIL:
      return {...state, outletDetail: payload.outletDetail}
    case OUTLET_PAGE_LIST_SET_OUTLET_SLOTS:
      return {...state, outletSlots: payload.slots}
    case OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS:
      return {...state, usedOutletSlots: payload.slots}
    case OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL:
      return {...state, showConfirmReactivateOutletModal: true}
    case OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL:
      return {...state, showConfirmReactivateOutletModal: false}
    case OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET:
      return {...state, reactivatedOutlet: payload.outlet}
    case OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN:
      return {...state, openRightColumn: true}
    case OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN:
      return {...state, openRightColumn: false}
    case OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL:
      return {...state, showAddOutletModal: true}
    case OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL:
      return {...state, showAddOutletModal: false}
    case OUTLET_PAGE_LIST_SET_OUTLET_PRICE:
      return {...state, outletPrice: payload.outletPrice}
    case OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS:
      return {...state, featureSubscriptions: payload.featureSubscriptions}
    case OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL:
      return {...state, showPaymentGatewayErrorModal: true}
    case OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL:
      return {...state, showPaymentGatewayErrorModal: false}
    case OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE:
      return {...state, payButtonMessage: payload.buttonMessage}
    case OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON:
      return {...state, disablePayButton: false}
    case OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON:
      return {...state, disablePayButton: true}
    case OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE:
      return {...state, pendingPaymentMessage: payload.pendingMessage}
    case OUTLET_PAGE_LIST_SET_ON_LOADING:
      return {...state, onLoadingPayButton: payload.onLoading}
    case OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON:
      return {...state, disableSaveOutletButton: payload.disabled}
    case OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY:
      return {...state, showReactivateOutletWithoutPayModal: true}
    case OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY:
      return {...state, showReactivateOutletWithoutPayModal: false}
    case OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL:
      return {...state, isOnLoadingReactivateOutletWithoutPayModal: payload.isOnLoading}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/outletPages/list.js